<template>
<div>
  <ImageFileField :scope="[...scope, 'image']" v-model:image-url="imgLink" :width='width' :height='height'/>
  <div class="row">
    <div class="col-5">
      <TextField
          :scope="[...scope, 'height']"
          v-model:model-value="height"
          placeholder="Enter height (optional)"
          disable-margin
      />
    </div>

    <div class="col-5">
      <TextField
          :scope="[...scope, 'width']"
          v-model:model-value="width"
          placeholder="Enter width (optional)"
          disable-margin
      />
    </div>

    <div class="col-2">
      <FormGroup :scope="[...scope, 'alignment']" :custom-label="humanize('alignment')">
        <div class="btn-group d-flex">
          <template v-for="pos in ['left', 'center', 'right']">
            <input
                :id="scopeToId([...scope, 'alignment', pos])"
                v-model="alignment"
                :value="pos"
                type="radio"
                :name="scopeToName([...scope, 'alignment'])"
                class="btn-check"
            >
            <label :for="scopeToId([...scope, 'alignment', pos])" class="btn btn-outline-dark">
              <i :class="`fas fa-align-${pos}`"/>
            </label>
          </template>
        </div>
      </FormGroup>
    </div>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { humanize, scopeToId, scopeToName } from "@/lib/candidacy/form_builder/utils";
import NumberField from "@/components/backend/candidacy/form_builder/form_items/shared/NumberField.vue";
import TextField from "@/components/backend/candidacy/form_builder/form_items/shared/TextField.vue";
import ImageFileField from "@/components/backend/candidacy/form_builder/form_items/shared/ImageFileField.vue";
import FormGroup from "@/components/backend/candidacy/form_builder/form_items/shared/FormGroup.vue";
import type { PageBlocksImage } from "@/types";

export default defineComponent({
  name: "Image",
  emits: ["update:pageBlock"],
  components: { FormGroup, ImageFileField, TextField, NumberField },
  methods: { scopeToName, scopeToId, humanize },
  props: {
    scope: {
      type: Array as PropType<string[]>,
      required: true,
    },
    pageBlock: {
      type: Object as PropType<PageBlocksImage>,
      required: true,
    },
  },
  data({ pageBlock }) {
    return {
      imgLink: pageBlock.image?.url || "",
      height: pageBlock.data.height || "",
      width: pageBlock.data.width || "",
      alignment: pageBlock.data.alignment || "left",
    }
  },
});
</script>
